import { render, staticRenderFns } from "./PaperAgendaItem.vue?vue&type=template&id=cf648180&scoped=true"
import script from "./PaperAgendaItem.vue?vue&type=script&lang=js"
export * from "./PaperAgendaItem.vue?vue&type=script&lang=js"
import style0 from "./PaperAgendaItem.vue?vue&type=style&index=0&id=cf648180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf648180",
  null
  
)

export default component.exports